import sdkProvider from "../../../../client/sdkProvider";
import setLoyaltyIsInvited from "./setLoyaltyIsInvited";
import logger from "../../../../lib/logger";
import config from "../../../../config/common";

const loadLoyaltyIsInvited = () => async dispatch => {
  try {
    const identitySdk = await sdkProvider("identity");
    const isAuthenticated = await identitySdk.customer.isAuthenticated();
    if (!isAuthenticated) {
      return;
    }

    const {
      loyalty: { invitationSegmentId }
    } = config;

    const featuresSdk = await sdkProvider("features");
    await featuresSdk.onReady();

    const isInviteAllUsersToLoyaltyFeatureEnabled = await featuresSdk
      .getFeature("loyalty_invite_all_eligible_users")
      .isEnabled();

    if (isInviteAllUsersToLoyaltyFeatureEnabled) {
      return dispatch(setLoyaltyIsInvited(true));
    }

    const audienceSdk = await sdkProvider("audience");
    const segments = await audienceSdk.getSegments();

    dispatch(
      setLoyaltyIsInvited(
        segments.some(({ segmentId }) => segmentId === invitationSegmentId)
      )
    );
  } catch (error) {
    error.message = `loadLoyaltyIsInvited failed with error: ${error.message}`;
    logger.error(error);
  }
};

export default loadLoyaltyIsInvited;
